export default "__VITE_ASSET__xUtCz9PU__"